// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/icon_logo_login.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/bg_login.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/icon_kakao.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/icon_naver.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/bg_joinok.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/bg_joinok_webmail.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/bg_loginok.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../img/icon_logo_login_m.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../img/icon_kakao@2x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../img/icon_naver@2x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../img/icon_error@2x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../img/icon_kakao@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../img/icon_naver@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../img/icon_error@3x.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

/********************************************* login *********************************************/
#login {
  position: relative;
  margin: 0 auto;
  min-height: 32rem;
  height: 100vh;
  background: #fff;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.login__left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60%;
  height: 100%;
  background: #003876;
  text-align: center;
  color: #fff;
}
.left__top {
  position: fixed;
  left: 2.5rem;
  top: 2.25rem;
  width: 4.5rem;
  height: 2.125rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: 100%;
}
.left__center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.left__center:after {
  content: "";
  width: 32.375rem;
  height: 11.263rem;
  padding-top: 5.365rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center bottom;
}
.left__center p {
  font-size: 2rem;
  font-weight: 100;
  line-height: 2.25rem;
  margin-bottom: 18px;
  color: #fff;
}
.left__center h1 {
  width: 432px;
  height: 40px;
  font-size: 2.375rem;
  font-weight: 700;
  line-height: 2.625rem;
  color: #fff;
}
.left__bottom {
  position: fixed;
  left: 2.5rem;
  bottom: 2.5rem;
  font-size: 0.75rem;
  font-weight: 400;
  color: #fff;
}
.login__right {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40%;
  height: 100%;
}
.login__right h2 p {
  font-size: 1.375rem;
  font-weight: 500;
  color: #2a2c2f;
}
.login__right h2 p:first-child {
  display: none;
}
.login__form .form__input {
  margin: 2.25rem 0 1.938rem;
}
.login__form .form__input li {
  margin-top: 1rem;
}
.login__form .form__input li:first-child {
  margin-top: 0;
}
.login__form .form__input .input__area {
  margin-left: 0;
}
.login__form .form__input input[type="text"],
.login__form .form__input input[type="password"] {
  width: 19.125rem;
  height: 2.75rem;
  padding: 0 1rem;
}
.login__form .input-errortxt {
  top: 3rem;
  font-size: 0.875rem;
  line-height: 1;
}
/* 로그인 입력 요소를 모두 컨테이너 전체폭으로 통일 (아이디/비밀번호/보안문자 입력란·이미지·로그인 버튼 동일 폭) */
.login__form .form__input .input__area input[type="text"],
.login__form .form__input .input__area input[type="password"] {
  width: 100%;
  box-sizing: border-box;
}
/* 비밀번호 표시 토글: 눈 아이콘이 있어도 전체폭 유지 + 오른쪽에 아이콘 자리 확보 */
.login__form .form__input .input__area:has(.btn-eye) input[type="password"],
.login__form .form__input .input__area:has(.btn-eye) input[type="text"] {
  width: 100%;
  box-sizing: border-box;
  padding: 0 2.75rem 0 1rem;
}
.login__form .form__input .input__area .btn-eye {
  right: 8px;
  left: unset;
}
/* 브라우저 자동완성(기억된 아이디/비번) 텍스트가 페이지 로드 시 작게 렌더되는 WebKit 버그 대응:
   :-webkit-autofill 에 애니메이션을 걸어 강제 리페인트 → CSS 폰트 크기로 정상 렌더 */
@keyframes loginAutofillFix {
  from {
    font-size: 1rem;
  }
  to {
    font-size: 1rem;
  }
}
.login__form .form__input input[type="text"]:-webkit-autofill,
.login__form .form__input input[type="password"]:-webkit-autofill {
  font-size: 1rem !important;
  animation-name: loginAutofillFix;
  animation-duration: 0.001s;
}
.login__form .form__etc {
  display: flex;
  align-items: center;
  justify-content: center;
}
.login__form .form__etc li:last-child {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.login__form .form__etc button:first-child:before {
  content: none;
}
.login__form .form__etc button::before {
  content: "";
  width: 1px;
  height: 0.658rem;
  margin-left: 0.499rem;
  padding-left: 0.499rem;
  border-left: 1px solid #909fb7;
}
.login__form .form__etc button span {
  font-size: 0.875rem;
}
.btn-login {
  margin: 1.813rem 0 1rem;
  background: #0a78ff;
  border: 0;
  width: 21.25rem;
  height: 2.875rem;
}
.btn-login:hover,
.btn-login:active {
  background: #0050b8;
}
.btn-login:disabled {
  background: #e9edef;
}
.btn-login span {
  color: #fff;
}
.join {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.join li {
  display: flex;
  align-items: center;
  justify-content: center;
}
.join li p {
  color: #909fb7;
  margin-right: 0.5rem;
}
.join__sns {
  margin: 3rem 0 3.5rem;
}
.join__sns button {
  width: 3rem;
  height: 3rem;
  background: #909fb7;
  border-radius: 50%;
  margin-left: 2rem;
}
.join__sns button:first-child {
  margin-left: 0;
}
.join__sns button.kakao {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center center #fae34c;
  background-size: 1.375rem;
}
.join__sns button.naver {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center center #03c75a;
  background-size: 1.25rem;
}
.select-lang {
  display: flex;
  align-items: center;
  justify-content: center;
}
.select-lang button {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 1.5rem;
  margin-left: 4.375rem;
}
.select-lang button:first-child {
  margin-left: 0;
}
.select-lang button:hover:after,
.select-lang button:active:after,
.select-lang button.on:after {
  content: "";
  display: block;
  width: 100%;
  padding-bottom: 0.375rem;
  border-bottom: 2px solid #0a78ff;
}
.select-lang button span {
  color: #909fb7;
}
.select-lang button:hover span,
.select-lang button:active span,
.select-lang button.on span {
  color: #0a78ff;
}

/* popup */
.login__popup.popup-layer {
  width: 28.75rem;
  /* min-height: 19.125rem; */
}
.login__popup .popup__body {
  width: calc(100% - 5rem);
  padding: 2rem 2.5rem 4.125rem;
}
.login__popup.popup-layer.w560 .popup__body .form__input label {
  width: 49%;
}
/* 회원가입 완료 */
/* .joinok {
  margin-bottom: -40px;
  margin-top: -25px !important;
} */
.joinok:before {
  content: "";
  width: 200px;
  height: 108px;
  display: block;
  margin: 0 auto 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center center;
  /* background-size: 1.25rem; */
}
.login__popup .popup__body.joinok-h {
  padding: 2rem 2.5rem 8.7rem;
}
.login__popup .popup__body.joinok-h .complete-txt {
  height: calc(75vh - 8.9rem);
}
.login__popup .popup__body.joinok-h .complete-txt button {
  margin-top: 33px;
  padding: 0 1.25rem;
  width: 8.75rem;
  height: 2.5rem;
  background-color: #0a78ff;
  border: 0;
}
.login__popup .popup__body.joinok-h .complete-txt button span {
  color: #fff;
  font-weight: 700;
}
.login__popup .popup__body.joinok-h .complete-txt button:hover {
  background-color: #0050b8;
}
.login__popup .popup__body.joinok-h .complete-txt button:active {
  background-color: #003876;
}
/* .login__popup .input__direct {
  width: 100%;
  margin-left: 2rem;
} */
.input__direct .input-error + .btn-delete {
  display: none;
}

/*회원가입완료_웹메일용*/
.login__popup .popup__body.joinok-h.webmail .joinok {
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  letter-spacing: -0.64px;
  color: #2a2c2f;
}
.login__popup .popup__body.joinok-h.webmail .joinok:before {
  content: "";
  width: 180px;
  height: 180px;
  display: block;
  margin-bottom: 26px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center center;
  background-size: 100%;
}
.login__popup .popup__body.joinok-h.webmail .complete-txt button {
  margin-top: 48px;
  padding: 0;
}
.login__popup .popup__body.joinok-h.webmail .joininfo {
  margin-top: 26px;
}
.login__popup .popup__body.joinok-h.webmail .joininfo p {
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  letter-spacing: -0.2px;
}
.login__popup .popup__body.joinok-h.webmail .joininfo .tit {
  font-size: 14px;
  color: #2a2c2f;
}
.login__popup .popup__body.joinok-h.webmail .joininfo .txt {
  margin-top: 6px;
  font-size: 13px;
  color: #7783a1;
}
.login__right.webmailok {
  background: none;
}
.login__right.webmailok h2 p:first-child.tit {
  display: block;
}
.login__right.webmailok .login__form .login__info {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  color: #2a2c2f;
}
.login__right.webmailok .login__form .login__info::before {
  content: "";
  margin: 35px 0 39px;
  width: 100px;
  height: 100px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center center;
  background-size: 100%;
}
.login__right.webmailok .login__form .login__info + .btn-login {
  margin-top: 23px;
}

/* 회원가입_이용약관 */
.popup-layer .terms {
  display: flex;
  flex-direction: column;
  height: calc(75vh - 7.1rem);
}
.popup-layer .terms li {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 30%;
  margin-top: 24px;
}
.popup-layer .terms li:first-child {
  margin-top: 0;
}
.popup-layer .terms .terms__tit {
  font-size: 15px;
  font-weight: 700;
  color: #2a2c2f;
  margin-bottom: 12px;
}
.popup-layer .terms .box-scroll {
  border: 1px solid #909fb7;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 13px;
  height: 100%;
  overflow-y: scroll;
  /* background: #fff; */
}
.popup-layer .terms p {
  font-size: 13px;
  line-height: 19.24px;
  word-wrap: break-word;
  word-break: break-all;
  margin-bottom: 1rem;
}
.popup-layer .terms p strong {
  font-weight: 700;
}
.popup-layer .terms p.tit {
  font-size: 14px;
  font-weight: 700;
  line-height: 20.72px;
}
.popup-layer .terms p.txt + p.tit {
  padding-top: 2.25rem;
}
.popup-layer .terms .tit-middle {
  font-weight: 700;
  padding-top: 1rem;
}
.popup-layer .terms p.tit + p.tit-small {
  padding-top: 0;
}
.popup-layer .terms p.tit-small {
  font-weight: 400;
  padding-top: 0.6rem;
  margin-bottom: 0;
}
.popup-layer .terms .renewday {
  color: #7783a1;
}
.popup-layer .terms .dot {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 0;
}
.popup-layer .terms .dot::before {
  content: "";
  width: 4px;
  height: 4px;
  background-color: #222;
  border-radius: 50%;
  margin: 8px 8px 0 5px;
}

/********************************************** For small screen, 반응형 **********************************************/
@media screen and (max-width: 1023px) {
  .login__left {
    display: none;
  }
  .login__right {
    width: 100%;
    height: auto;
    min-height: calc(100vh - 40%);
    padding: 20% 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat 2rem 2.5rem;
    background-size: 4.5rem 2.125rem;
  }
  .login__right h2 p:first-child {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .login__right h2 p:first-child span {
    font-size: 1.375rem;
    font-weight: 300;
    color: #2a2c2f;
  }
  .login__right h2 p:first-child span:last-child {
    font-size: 2.188rem;
    font-weight: 700;
    color: #003876;
    margin-top: 24px;
    height: 30px;
    width: 328px;
  }
  .login__right h2 p:last-child {
    display: none;
  }
  .join__sns button {
    margin-left: 1.5rem;
  }
  .btn-login {
    margin: 3.688rem 0 1rem;
  }
  .login__form .form__input {
    margin: 4rem 0 1.938rem;
  }
  .login__form .form__input li {
    margin-top: 0.5rem;
  }
  .join__sns button {
    width: 3.5rem;
    height: 3.5rem;
  }
  .join__sns button.kakao {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat center center #fae34c;
    background-size: 1.375rem;
  }
  .join__sns button.naver {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat center center #03c75a;
    background-size: 1.25rem;
  }
}
@media screen and (max-width: 500px) {
  .login__popup.popup-layer {
    /* position: absolute ; */
    width: calc(100% - 2rem) !important;
    padding: 0 1rem;
    /* top: 0 !important;
    left: 0 !important; */
    /* min-height: calc(100vh - 71px); */
    box-shadow: none;
    background-color: #fff;
    border-radius: 0;
    overflow-y: auto;
    /* min-height: 100%; */
    justify-content: center;
    align-items: center;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    padding-top: 121px;
  }
  .login__popup .popup__head {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;
    background-color: #fff;
    flex-direction: column-reverse;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .login__popup .popup__head h1 {
    font-size: 30px;
    font-weight: 500;
  }
  .login__popup .popup__head .btn-close {
    margin-bottom: 18px;
  }
  .login__popup .popup__body {
    overflow-y: unset;
    /* margin-top: 7.563rem; */
    margin-top: 0;
    padding: 0;
    width: 100%;
    min-height: calc(100vh - 225px);
    /* min-height: calc(100vh - 225px); */
    max-height: unset;
    background-color: #fff;
  }
  .login__popup .popup__body.joinok-h {
    padding: 0;
  }
  .form__input li:not(.form__input .filelist li) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: 1.25rem;
  }
  .form__input .input__area {
    margin-left: 0;
  }
  .login__popup.popup-layer .popup__body .form__input label {
    width: 100% !important;
    margin-bottom: 8px;
  }
  .login__popup.popup-layer .popup__body .form__input .checkBox.column label {
    width: auto !important;
  }
  .login__popup.popup-layer .popup__body .form__input .checkBox.column li.ml-50 label {
    width: calc(100% - 70px) !important;
  }
  .login__popup .popup__footer {
    padding-bottom: 3rem;
    border-top: 0;
  }
  .login__popup .input-errortxt {
    font-size: 13px;
    top: 44px;
  }
  .login__popup .popup__body .form__input input[type="text"],
  .login__popup .popup__body .form__input input[type="password"],
  .login__popup .popup__body .form__input input[type="tel"],
  .login__popup .select {
    height: 40px;
    font-size: 1rem;
  }

  .login__popup .popup__body .form__input input[type="text"].input-error,
  .login__popup .popup__body .form__input input[type="password"].input-error,
  .login__popup .popup__body .form__input input[type="tel"].input-error {
    background: none;
  }
  .joinok {
    margin: 0 !important;
  }
  .terms .terms__tit {
    font-size: 1rem;
  }
  .login__popup .popup__body.joinok-h.webmail .joinok:before {
    width: 100px;
    height: 100px;
  }
  .login__popup .popup__body.joinok-h.webmail .complete-txt {
    height: calc(75vh - 3rem);
  }
}
@media screen and (max-width: 414px) {
  .login__right {
    min-height: calc(100vh - 80%);
    padding: 40% 0;
  }
}
@media screen and (max-width: 390px) {
  #login {
    width: calc(100% - 2.5rem);
    height: auto;
    min-height: auto;
    margin: 13% auto 20%;
  }
  .login__right {
    height: auto;
    min-height: auto;
    padding: 0;
    background-size: 2.8rem;
    background-position: 0.25rem 0;
  }
  .login__right h2 {
    padding: 28% 0 0;
  }
  .login__form {
    width: 100%;
  }
  .login__form .form__input {
    margin: 2.5rem 0;
  }
  .login__form .form__input input[type="text"],
  .login__form .form__input input[type="password"] {
    width: calc(100% - 2.125rem);
  }
  .btn-login {
    margin: 2.5rem 0 1rem;
    width: 100%;
  }
  .join__sns {
    margin: 2rem 0 2.5rem;
  }
  .select-lang button {
    margin-left: 2.75rem;
  }
  .login__popup .popup__body {
    /* margin-top: 4.5rem; */
  }
}
@media screen and (max-width: 320px) {
  .login__right {
    background-size: 2.8rem;
  }
  .login__right h2 p:first-child span {
    font-size: 1rem;
  }
  .login__right h2 p:first-child span:last-child {
    font-size: 2rem;
    margin-top: 20px;
    width: auto;
  }
  .join li {
    font-size: 0.875rem;
  }
  .join__sns button {
    width: 3rem;
    height: 3rem;
  }
  .select-lang button {
    font-size: 0.875rem;
  }
  input[type="checkbox"] + label {
    font-size: 0.875rem;
    padding-left: 1.438rem;
  }
  input[type="checkbox"] + label:before {
    width: 1.125rem;
    height: 1.125rem;
    top: -2px;
  }
  input[type="checkbox"]:checked + label:after {
    top: -2px;
  }
}
@media screen and (max-width: 319px) {
  #login {
    min-width: 16.875rem;
    padding: 0 1.25rem;
  }
}

/********************************************** background image size **********************************************/
@media only screen and (-webkit-min-device-pixel-ratio: 2),
  only screen and (min-device-pixel-ratio: 2),
  only screen and (min-resolution: 2dppx) {
  .join__sns button.kakao {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  }
  .join__sns button.naver {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  }
  /* .login__right {
    background-image: url("../img/icon_logo_login_m@2x.png");
  } */
  .form__input input[type="text"].input-error,
  .form__input input[type="password"].input-error,
  .form__input input[type="tel"].input-error {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  }
}
@media only screen and (-webkit-min-device-pixel-ratio: 3),
  only screen and (min-device-pixel-ratio: 3),
  only screen and (min-resolution: 3dppx) {
  .join__sns button.kakao {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  }
  .join__sns button.naver {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  }
  /* .login__right {
    background-image: url("../img/icon_logo_login_m@3x.png");
  } */
  .form__input input[type="text"].input-error,
  .form__input input[type="password"].input-error,
  .form__input input[type="tel"].input-error {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  }
}

/********************************************* login type2 *********************************************/
.login.type2 .login__left {
  background: #0a1e5a;
}
.login.type2 .left__center::after {
  display: none;
}
.login.type2 .left__center p {
  margin-bottom: 24px;
}
.login.type2 .left__center h1 {
  width: 517px;
  height: 70px;
}
@media screen and (max-width: 1023px) {
  .login.type2 .login__right h2 p:first-child span:last-child {
    margin-top: 16px;
    height: 40px;
    width: 295.72px;
  }
}
`, "",{"version":3,"sources":["webpack://./static/css/login.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,kGAAkG;AAClG;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,2EAAqE;EACrE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,2EAA8D;AAChE;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;AACA,oEAAoE;AACpE;;EAEE,WAAW;EACX,sBAAsB;AACxB;AACA,mDAAmD;AACnD;;EAEE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;6DAC6D;AAC7D;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;;EAEE,0BAA0B;EAC1B,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,mFAAwE;EACxE,yBAAyB;AAC3B;AACA;EACE,mFAAwE;EACxE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,WAAW;EACX,cAAc;EACd,WAAW;EACX,wBAAwB;EACxB,gCAAgC;AAClC;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA,YAAY;AACZ;;;GAGG;AACH;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,2EAA+D;EAC/D,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;;GAGG;AACH;EACE,aAAa;AACf;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,2EAAuE;EACvE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,2EAAgE;EAChE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,oHAAoH;AACpH;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,yEAAqE;IACrE,gCAAgC;EAClC;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,cAAc;EAChB;EACA;IACE,mFAA2E;IAC3E,yBAAyB;EAC3B;EACA;IACE,mFAA2E;IAC3E,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,yBAAyB;IACzB,mCAAmC;IACnC,eAAe;IACf;yBACqB;IACrB,oCAAoC;IACpC,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,OAAO;IACP,MAAM;IACN,WAAW;IACX,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,aAAa;IACb,UAAU;IACV,WAAW;IACX,+BAA+B;IAC/B,qCAAqC;IACrC,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mCAAmC;EACrC;EACA;IACE,oBAAoB;IACpB,aAAa;EACf;EACA;IACE,eAAe;IACf,SAAS;EACX;EACA;;;;IAIE,YAAY;IACZ,eAAe;EACjB;;EAEA;;;IAGE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,6BAA6B;IAC7B,cAAc;EAChB;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,uBAAuB;IACvB,8BAA8B;EAChC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;IACrB,WAAW;EACb;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,oBAAoB;IACpB,kBAAkB;EACpB;AACF;;AAEA,oHAAoH;AACpH;;;EAGE;IACE,yDAAiD;EACnD;EACA;IACE,yDAAiD;EACnD;EACA;;KAEG;EACH;;;IAGE,0DAAiD;EACnD;AACF;AACA;;;EAGE;IACE,0DAAiD;EACnD;EACA;IACE,0DAAiD;EACnD;EACA;;KAEG;EACH;;;IAGE,0DAAiD;EACnD;AACF;;AAEA,wGAAwG;AACxG;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["@charset \"UTF-8\";\r\n\r\n/********************************************* login *********************************************/\r\n#login {\r\n  position: relative;\r\n  margin: 0 auto;\r\n  min-height: 32rem;\r\n  height: 100vh;\r\n  background: #fff;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n}\r\n.login__left {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 60%;\r\n  height: 100%;\r\n  background: #003876;\r\n  text-align: center;\r\n  color: #fff;\r\n}\r\n.left__top {\r\n  position: fixed;\r\n  left: 2.5rem;\r\n  top: 2.25rem;\r\n  width: 4.5rem;\r\n  height: 2.125rem;\r\n  background: url(\"../img/icon_logo_login.png\") no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.left__center {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.left__center:after {\r\n  content: \"\";\r\n  width: 32.375rem;\r\n  height: 11.263rem;\r\n  padding-top: 5.365rem;\r\n  background: url(\"../img/bg_login.png\") no-repeat center bottom;\r\n}\r\n.left__center p {\r\n  font-size: 2rem;\r\n  font-weight: 100;\r\n  line-height: 2.25rem;\r\n  margin-bottom: 18px;\r\n  color: #fff;\r\n}\r\n.left__center h1 {\r\n  width: 432px;\r\n  height: 40px;\r\n  font-size: 2.375rem;\r\n  font-weight: 700;\r\n  line-height: 2.625rem;\r\n  color: #fff;\r\n}\r\n.left__bottom {\r\n  position: fixed;\r\n  left: 2.5rem;\r\n  bottom: 2.5rem;\r\n  font-size: 0.75rem;\r\n  font-weight: 400;\r\n  color: #fff;\r\n}\r\n.login__right {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 40%;\r\n  height: 100%;\r\n}\r\n.login__right h2 p {\r\n  font-size: 1.375rem;\r\n  font-weight: 500;\r\n  color: #2a2c2f;\r\n}\r\n.login__right h2 p:first-child {\r\n  display: none;\r\n}\r\n.login__form .form__input {\r\n  margin: 2.25rem 0 1.938rem;\r\n}\r\n.login__form .form__input li {\r\n  margin-top: 1rem;\r\n}\r\n.login__form .form__input li:first-child {\r\n  margin-top: 0;\r\n}\r\n.login__form .form__input .input__area {\r\n  margin-left: 0;\r\n}\r\n.login__form .form__input input[type=\"text\"],\r\n.login__form .form__input input[type=\"password\"] {\r\n  width: 19.125rem;\r\n  height: 2.75rem;\r\n  padding: 0 1rem;\r\n}\r\n.login__form .input-errortxt {\r\n  top: 3rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1;\r\n}\r\n/* 로그인 입력 요소를 모두 컨테이너 전체폭으로 통일 (아이디/비밀번호/보안문자 입력란·이미지·로그인 버튼 동일 폭) */\r\n.login__form .form__input .input__area input[type=\"text\"],\r\n.login__form .form__input .input__area input[type=\"password\"] {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n/* 비밀번호 표시 토글: 눈 아이콘이 있어도 전체폭 유지 + 오른쪽에 아이콘 자리 확보 */\r\n.login__form .form__input .input__area:has(.btn-eye) input[type=\"password\"],\r\n.login__form .form__input .input__area:has(.btn-eye) input[type=\"text\"] {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  padding: 0 2.75rem 0 1rem;\r\n}\r\n.login__form .form__input .input__area .btn-eye {\r\n  right: 8px;\r\n  left: unset;\r\n}\r\n/* 브라우저 자동완성(기억된 아이디/비번) 텍스트가 페이지 로드 시 작게 렌더되는 WebKit 버그 대응:\r\n   :-webkit-autofill 에 애니메이션을 걸어 강제 리페인트 → CSS 폰트 크기로 정상 렌더 */\r\n@keyframes loginAutofillFix {\r\n  from {\r\n    font-size: 1rem;\r\n  }\r\n  to {\r\n    font-size: 1rem;\r\n  }\r\n}\r\n.login__form .form__input input[type=\"text\"]:-webkit-autofill,\r\n.login__form .form__input input[type=\"password\"]:-webkit-autofill {\r\n  font-size: 1rem !important;\r\n  animation-name: loginAutofillFix;\r\n  animation-duration: 0.001s;\r\n}\r\n.login__form .form__etc {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.login__form .form__etc li:last-child {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n}\r\n.login__form .form__etc button:first-child:before {\r\n  content: none;\r\n}\r\n.login__form .form__etc button::before {\r\n  content: \"\";\r\n  width: 1px;\r\n  height: 0.658rem;\r\n  margin-left: 0.499rem;\r\n  padding-left: 0.499rem;\r\n  border-left: 1px solid #909fb7;\r\n}\r\n.login__form .form__etc button span {\r\n  font-size: 0.875rem;\r\n}\r\n.btn-login {\r\n  margin: 1.813rem 0 1rem;\r\n  background: #0a78ff;\r\n  border: 0;\r\n  width: 21.25rem;\r\n  height: 2.875rem;\r\n}\r\n.btn-login:hover,\r\n.btn-login:active {\r\n  background: #0050b8;\r\n}\r\n.btn-login:disabled {\r\n  background: #e9edef;\r\n}\r\n.btn-login span {\r\n  color: #fff;\r\n}\r\n.join {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n.join li {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.join li p {\r\n  color: #909fb7;\r\n  margin-right: 0.5rem;\r\n}\r\n.join__sns {\r\n  margin: 3rem 0 3.5rem;\r\n}\r\n.join__sns button {\r\n  width: 3rem;\r\n  height: 3rem;\r\n  background: #909fb7;\r\n  border-radius: 50%;\r\n  margin-left: 2rem;\r\n}\r\n.join__sns button:first-child {\r\n  margin-left: 0;\r\n}\r\n.join__sns button.kakao {\r\n  background: url(\"../img/icon_kakao.png\") no-repeat center center #fae34c;\r\n  background-size: 1.375rem;\r\n}\r\n.join__sns button.naver {\r\n  background: url(\"../img/icon_naver.png\") no-repeat center center #03c75a;\r\n  background-size: 1.25rem;\r\n}\r\n.select-lang {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.select-lang button {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  height: 1.5rem;\r\n  margin-left: 4.375rem;\r\n}\r\n.select-lang button:first-child {\r\n  margin-left: 0;\r\n}\r\n.select-lang button:hover:after,\r\n.select-lang button:active:after,\r\n.select-lang button.on:after {\r\n  content: \"\";\r\n  display: block;\r\n  width: 100%;\r\n  padding-bottom: 0.375rem;\r\n  border-bottom: 2px solid #0a78ff;\r\n}\r\n.select-lang button span {\r\n  color: #909fb7;\r\n}\r\n.select-lang button:hover span,\r\n.select-lang button:active span,\r\n.select-lang button.on span {\r\n  color: #0a78ff;\r\n}\r\n\r\n/* popup */\r\n.login__popup.popup-layer {\r\n  width: 28.75rem;\r\n  /* min-height: 19.125rem; */\r\n}\r\n.login__popup .popup__body {\r\n  width: calc(100% - 5rem);\r\n  padding: 2rem 2.5rem 4.125rem;\r\n}\r\n.login__popup.popup-layer.w560 .popup__body .form__input label {\r\n  width: 49%;\r\n}\r\n/* 회원가입 완료 */\r\n/* .joinok {\r\n  margin-bottom: -40px;\r\n  margin-top: -25px !important;\r\n} */\r\n.joinok:before {\r\n  content: \"\";\r\n  width: 200px;\r\n  height: 108px;\r\n  display: block;\r\n  margin: 0 auto 16px;\r\n  background: url(\"../img/bg_joinok.png\") no-repeat center center;\r\n  /* background-size: 1.25rem; */\r\n}\r\n.login__popup .popup__body.joinok-h {\r\n  padding: 2rem 2.5rem 8.7rem;\r\n}\r\n.login__popup .popup__body.joinok-h .complete-txt {\r\n  height: calc(75vh - 8.9rem);\r\n}\r\n.login__popup .popup__body.joinok-h .complete-txt button {\r\n  margin-top: 33px;\r\n  padding: 0 1.25rem;\r\n  width: 8.75rem;\r\n  height: 2.5rem;\r\n  background-color: #0a78ff;\r\n  border: 0;\r\n}\r\n.login__popup .popup__body.joinok-h .complete-txt button span {\r\n  color: #fff;\r\n  font-weight: 700;\r\n}\r\n.login__popup .popup__body.joinok-h .complete-txt button:hover {\r\n  background-color: #0050b8;\r\n}\r\n.login__popup .popup__body.joinok-h .complete-txt button:active {\r\n  background-color: #003876;\r\n}\r\n/* .login__popup .input__direct {\r\n  width: 100%;\r\n  margin-left: 2rem;\r\n} */\r\n.input__direct .input-error + .btn-delete {\r\n  display: none;\r\n}\r\n\r\n/*회원가입완료_웹메일용*/\r\n.login__popup .popup__body.joinok-h.webmail .joinok {\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 26px;\r\n  text-align: center;\r\n  letter-spacing: -0.64px;\r\n  color: #2a2c2f;\r\n}\r\n.login__popup .popup__body.joinok-h.webmail .joinok:before {\r\n  content: \"\";\r\n  width: 180px;\r\n  height: 180px;\r\n  display: block;\r\n  margin-bottom: 26px;\r\n  background: url(\"../img/bg_joinok_webmail.png\") no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.login__popup .popup__body.joinok-h.webmail .complete-txt button {\r\n  margin-top: 48px;\r\n  padding: 0;\r\n}\r\n.login__popup .popup__body.joinok-h.webmail .joininfo {\r\n  margin-top: 26px;\r\n}\r\n.login__popup .popup__body.joinok-h.webmail .joininfo p {\r\n  font-weight: 400;\r\n  line-height: 20px;\r\n  text-align: center;\r\n  letter-spacing: -0.2px;\r\n}\r\n.login__popup .popup__body.joinok-h.webmail .joininfo .tit {\r\n  font-size: 14px;\r\n  color: #2a2c2f;\r\n}\r\n.login__popup .popup__body.joinok-h.webmail .joininfo .txt {\r\n  margin-top: 6px;\r\n  font-size: 13px;\r\n  color: #7783a1;\r\n}\r\n.login__right.webmailok {\r\n  background: none;\r\n}\r\n.login__right.webmailok h2 p:first-child.tit {\r\n  display: block;\r\n}\r\n.login__right.webmailok .login__form .login__info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  line-height: 22px;\r\n  text-align: center;\r\n  color: #2a2c2f;\r\n}\r\n.login__right.webmailok .login__form .login__info::before {\r\n  content: \"\";\r\n  margin: 35px 0 39px;\r\n  width: 100px;\r\n  height: 100px;\r\n  background: url(\"../img/bg_loginok.png\") no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.login__right.webmailok .login__form .login__info + .btn-login {\r\n  margin-top: 23px;\r\n}\r\n\r\n/* 회원가입_이용약관 */\r\n.popup-layer .terms {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: calc(75vh - 7.1rem);\r\n}\r\n.popup-layer .terms li {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  min-height: 30%;\r\n  margin-top: 24px;\r\n}\r\n.popup-layer .terms li:first-child {\r\n  margin-top: 0;\r\n}\r\n.popup-layer .terms .terms__tit {\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  color: #2a2c2f;\r\n  margin-bottom: 12px;\r\n}\r\n.popup-layer .terms .box-scroll {\r\n  border: 1px solid #909fb7;\r\n  border-radius: 4px;\r\n  padding: 6px 8px;\r\n  font-size: 13px;\r\n  height: 100%;\r\n  overflow-y: scroll;\r\n  /* background: #fff; */\r\n}\r\n.popup-layer .terms p {\r\n  font-size: 13px;\r\n  line-height: 19.24px;\r\n  word-wrap: break-word;\r\n  word-break: break-all;\r\n  margin-bottom: 1rem;\r\n}\r\n.popup-layer .terms p strong {\r\n  font-weight: 700;\r\n}\r\n.popup-layer .terms p.tit {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  line-height: 20.72px;\r\n}\r\n.popup-layer .terms p.txt + p.tit {\r\n  padding-top: 2.25rem;\r\n}\r\n.popup-layer .terms .tit-middle {\r\n  font-weight: 700;\r\n  padding-top: 1rem;\r\n}\r\n.popup-layer .terms p.tit + p.tit-small {\r\n  padding-top: 0;\r\n}\r\n.popup-layer .terms p.tit-small {\r\n  font-weight: 400;\r\n  padding-top: 0.6rem;\r\n  margin-bottom: 0;\r\n}\r\n.popup-layer .terms .renewday {\r\n  color: #7783a1;\r\n}\r\n.popup-layer .terms .dot {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n  margin-bottom: 0;\r\n}\r\n.popup-layer .terms .dot::before {\r\n  content: \"\";\r\n  width: 4px;\r\n  height: 4px;\r\n  background-color: #222;\r\n  border-radius: 50%;\r\n  margin: 8px 8px 0 5px;\r\n}\r\n\r\n/********************************************** For small screen, 반응형 **********************************************/\r\n@media screen and (max-width: 1023px) {\r\n  .login__left {\r\n    display: none;\r\n  }\r\n  .login__right {\r\n    width: 100%;\r\n    height: auto;\r\n    min-height: calc(100vh - 40%);\r\n    padding: 20% 0;\r\n    background: url(\"../img/icon_logo_login_m.png\") no-repeat 2rem 2.5rem;\r\n    background-size: 4.5rem 2.125rem;\r\n  }\r\n  .login__right h2 p:first-child {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  .login__right h2 p:first-child span {\r\n    font-size: 1.375rem;\r\n    font-weight: 300;\r\n    color: #2a2c2f;\r\n  }\r\n  .login__right h2 p:first-child span:last-child {\r\n    font-size: 2.188rem;\r\n    font-weight: 700;\r\n    color: #003876;\r\n    margin-top: 24px;\r\n    height: 30px;\r\n    width: 328px;\r\n  }\r\n  .login__right h2 p:last-child {\r\n    display: none;\r\n  }\r\n  .join__sns button {\r\n    margin-left: 1.5rem;\r\n  }\r\n  .btn-login {\r\n    margin: 3.688rem 0 1rem;\r\n  }\r\n  .login__form .form__input {\r\n    margin: 4rem 0 1.938rem;\r\n  }\r\n  .login__form .form__input li {\r\n    margin-top: 0.5rem;\r\n  }\r\n  .join__sns button {\r\n    width: 3.5rem;\r\n    height: 3.5rem;\r\n  }\r\n  .join__sns button.kakao {\r\n    background: url(\"../img/icon_kakao@2x.png\") no-repeat center center #fae34c;\r\n    background-size: 1.375rem;\r\n  }\r\n  .join__sns button.naver {\r\n    background: url(\"../img/icon_naver@2x.png\") no-repeat center center #03c75a;\r\n    background-size: 1.25rem;\r\n  }\r\n}\r\n@media screen and (max-width: 500px) {\r\n  .login__popup.popup-layer {\r\n    /* position: absolute ; */\r\n    width: calc(100% - 2rem) !important;\r\n    padding: 0 1rem;\r\n    /* top: 0 !important;\r\n    left: 0 !important; */\r\n    /* min-height: calc(100vh - 71px); */\r\n    box-shadow: none;\r\n    background-color: #fff;\r\n    border-radius: 0;\r\n    overflow-y: auto;\r\n    /* min-height: 100%; */\r\n    justify-content: center;\r\n    align-items: center;\r\n    position: fixed !important;\r\n    top: 0 !important;\r\n    left: 0 !important;\r\n    right: 0 !important;\r\n    bottom: 0 !important;\r\n    padding-top: 121px;\r\n  }\r\n  .login__popup .popup__head {\r\n    position: fixed;\r\n    left: 0;\r\n    top: 0;\r\n    z-index: 10;\r\n    background-color: #fff;\r\n    flex-direction: column-reverse;\r\n    align-items: flex-start;\r\n    justify-content: flex-start;\r\n  }\r\n  .login__popup .popup__head h1 {\r\n    font-size: 30px;\r\n    font-weight: 500;\r\n  }\r\n  .login__popup .popup__head .btn-close {\r\n    margin-bottom: 18px;\r\n  }\r\n  .login__popup .popup__body {\r\n    overflow-y: unset;\r\n    /* margin-top: 7.563rem; */\r\n    margin-top: 0;\r\n    padding: 0;\r\n    width: 100%;\r\n    min-height: calc(100vh - 225px);\r\n    /* min-height: calc(100vh - 225px); */\r\n    max-height: unset;\r\n    background-color: #fff;\r\n  }\r\n  .login__popup .popup__body.joinok-h {\r\n    padding: 0;\r\n  }\r\n  .form__input li:not(.form__input .filelist li) {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    justify-content: flex-start;\r\n    margin-top: 1.25rem;\r\n  }\r\n  .form__input .input__area {\r\n    margin-left: 0;\r\n  }\r\n  .login__popup.popup-layer .popup__body .form__input label {\r\n    width: 100% !important;\r\n    margin-bottom: 8px;\r\n  }\r\n  .login__popup.popup-layer .popup__body .form__input .checkBox.column label {\r\n    width: auto !important;\r\n  }\r\n  .login__popup.popup-layer .popup__body .form__input .checkBox.column li.ml-50 label {\r\n    width: calc(100% - 70px) !important;\r\n  }\r\n  .login__popup .popup__footer {\r\n    padding-bottom: 3rem;\r\n    border-top: 0;\r\n  }\r\n  .login__popup .input-errortxt {\r\n    font-size: 13px;\r\n    top: 44px;\r\n  }\r\n  .login__popup .popup__body .form__input input[type=\"text\"],\r\n  .login__popup .popup__body .form__input input[type=\"password\"],\r\n  .login__popup .popup__body .form__input input[type=\"tel\"],\r\n  .login__popup .select {\r\n    height: 40px;\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .login__popup .popup__body .form__input input[type=\"text\"].input-error,\r\n  .login__popup .popup__body .form__input input[type=\"password\"].input-error,\r\n  .login__popup .popup__body .form__input input[type=\"tel\"].input-error {\r\n    background: none;\r\n  }\r\n  .joinok {\r\n    margin: 0 !important;\r\n  }\r\n  .terms .terms__tit {\r\n    font-size: 1rem;\r\n  }\r\n  .login__popup .popup__body.joinok-h.webmail .joinok:before {\r\n    width: 100px;\r\n    height: 100px;\r\n  }\r\n  .login__popup .popup__body.joinok-h.webmail .complete-txt {\r\n    height: calc(75vh - 3rem);\r\n  }\r\n}\r\n@media screen and (max-width: 414px) {\r\n  .login__right {\r\n    min-height: calc(100vh - 80%);\r\n    padding: 40% 0;\r\n  }\r\n}\r\n@media screen and (max-width: 390px) {\r\n  #login {\r\n    width: calc(100% - 2.5rem);\r\n    height: auto;\r\n    min-height: auto;\r\n    margin: 13% auto 20%;\r\n  }\r\n  .login__right {\r\n    height: auto;\r\n    min-height: auto;\r\n    padding: 0;\r\n    background-size: 2.8rem;\r\n    background-position: 0.25rem 0;\r\n  }\r\n  .login__right h2 {\r\n    padding: 28% 0 0;\r\n  }\r\n  .login__form {\r\n    width: 100%;\r\n  }\r\n  .login__form .form__input {\r\n    margin: 2.5rem 0;\r\n  }\r\n  .login__form .form__input input[type=\"text\"],\r\n  .login__form .form__input input[type=\"password\"] {\r\n    width: calc(100% - 2.125rem);\r\n  }\r\n  .btn-login {\r\n    margin: 2.5rem 0 1rem;\r\n    width: 100%;\r\n  }\r\n  .join__sns {\r\n    margin: 2rem 0 2.5rem;\r\n  }\r\n  .select-lang button {\r\n    margin-left: 2.75rem;\r\n  }\r\n  .login__popup .popup__body {\r\n    /* margin-top: 4.5rem; */\r\n  }\r\n}\r\n@media screen and (max-width: 320px) {\r\n  .login__right {\r\n    background-size: 2.8rem;\r\n  }\r\n  .login__right h2 p:first-child span {\r\n    font-size: 1rem;\r\n  }\r\n  .login__right h2 p:first-child span:last-child {\r\n    font-size: 2rem;\r\n    margin-top: 20px;\r\n    width: auto;\r\n  }\r\n  .join li {\r\n    font-size: 0.875rem;\r\n  }\r\n  .join__sns button {\r\n    width: 3rem;\r\n    height: 3rem;\r\n  }\r\n  .select-lang button {\r\n    font-size: 0.875rem;\r\n  }\r\n  input[type=\"checkbox\"] + label {\r\n    font-size: 0.875rem;\r\n    padding-left: 1.438rem;\r\n  }\r\n  input[type=\"checkbox\"] + label:before {\r\n    width: 1.125rem;\r\n    height: 1.125rem;\r\n    top: -2px;\r\n  }\r\n  input[type=\"checkbox\"]:checked + label:after {\r\n    top: -2px;\r\n  }\r\n}\r\n@media screen and (max-width: 319px) {\r\n  #login {\r\n    min-width: 16.875rem;\r\n    padding: 0 1.25rem;\r\n  }\r\n}\r\n\r\n/********************************************** background image size **********************************************/\r\n@media only screen and (-webkit-min-device-pixel-ratio: 2),\r\n  only screen and (min-device-pixel-ratio: 2),\r\n  only screen and (min-resolution: 2dppx) {\r\n  .join__sns button.kakao {\r\n    background-image: url(\"../img/icon_kakao@2x.png\");\r\n  }\r\n  .join__sns button.naver {\r\n    background-image: url(\"../img/icon_naver@2x.png\");\r\n  }\r\n  /* .login__right {\r\n    background-image: url(\"../img/icon_logo_login_m@2x.png\");\r\n  } */\r\n  .form__input input[type=\"text\"].input-error,\r\n  .form__input input[type=\"password\"].input-error,\r\n  .form__input input[type=\"tel\"].input-error {\r\n    background-image: url(\"../img/icon_error@2x.png\");\r\n  }\r\n}\r\n@media only screen and (-webkit-min-device-pixel-ratio: 3),\r\n  only screen and (min-device-pixel-ratio: 3),\r\n  only screen and (min-resolution: 3dppx) {\r\n  .join__sns button.kakao {\r\n    background-image: url(\"../img/icon_kakao@3x.png\");\r\n  }\r\n  .join__sns button.naver {\r\n    background-image: url(\"../img/icon_naver@3x.png\");\r\n  }\r\n  /* .login__right {\r\n    background-image: url(\"../img/icon_logo_login_m@3x.png\");\r\n  } */\r\n  .form__input input[type=\"text\"].input-error,\r\n  .form__input input[type=\"password\"].input-error,\r\n  .form__input input[type=\"tel\"].input-error {\r\n    background-image: url(\"../img/icon_error@3x.png\");\r\n  }\r\n}\r\n\r\n/********************************************* login type2 *********************************************/\r\n.login.type2 .login__left {\r\n  background: #0a1e5a;\r\n}\r\n.login.type2 .left__center::after {\r\n  display: none;\r\n}\r\n.login.type2 .left__center p {\r\n  margin-bottom: 24px;\r\n}\r\n.login.type2 .left__center h1 {\r\n  width: 517px;\r\n  height: 70px;\r\n}\r\n@media screen and (max-width: 1023px) {\r\n  .login.type2 .login__right h2 p:first-child span:last-child {\r\n    margin-top: 16px;\r\n    height: 40px;\r\n    width: 295.72px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
